import * as React from "react";
import * as i from "../../../../../contracts";

export const renderEventName = (event: i.Event, componentPrefix: string) => {
    return (
        <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__event-name`} data-uat={`div-ev-list-${componentPrefix}-event-name`}>
            <span className="rj-ev-list__name-text" data-uat="span-ev-list-name-text">{event.eventName}</span>
        </div>
    )
}